export default __webpack_public_path__ + "static/media/AMGAS-words.c04d0f2a.png";